class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('cart-drawer');
    this.backdrop = document.getElementById('cart-drawer-backdrop');
    this.closeBtn = document.getElementById('cart-drawer-close');
    this.continueBtn = document.getElementById('cart-continue-btn');
    
    this.bindEvents();
  }

  bindEvents() {
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
    if (this.continueBtn) this.continueBtn.addEventListener('click', this.close.bind(this));
    if (this.backdrop) this.backdrop.addEventListener('click', this.close.bind(this));

    document.querySelectorAll('[data-cart-open]').forEach(icon => {
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.drawer.addEventListener('click', (e) => {
      const decreaseBtn = e.target.closest('[data-action="decrease"]');
      const increaseBtn = e.target.closest('[data-action="increase"]');
      const removeBtn = e.target.closest('.cart-item-remove');

      if (decreaseBtn) {
        const key = decreaseBtn.dataset.key;
        const qty = parseInt(decreaseBtn.dataset.qty) - 1;
        this.updateItem(key, qty);
      }
      if (increaseBtn) {
        const key = increaseBtn.dataset.key;
        const qty = parseInt(increaseBtn.dataset.qty) + 1;
        this.updateItem(key, qty);
      }
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        this.updateItem(key, 0);
      }
    });
  }

  open() {
    this.drawer.classList.add('is-active');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.backdrop) {
      this.backdrop.classList.add('is-active');
      this.backdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-active');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.backdrop) {
      this.backdrop.classList.remove('is-active');
      this.backdrop.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }

  async updateItem(key, quantity) {
    this.drawer.classList.add('is-loading');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      await this.renderCart(cart);
    } catch (error) {
      console.error('Error updating cart:', error);
    }
    this.drawer.classList.remove('is-loading');
  }

  async renderCart(cartData) {
    const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    
    const newDrawer = html.getElementById('cart-drawer');
    if (newDrawer) {
      this.drawer.innerHTML = newDrawer.innerHTML;
      this.bindEvents(); // Re-bind since innerHTML replaced the buttons
    }

    // Update header cart count
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cartData.item_count;
      el.hidden = cartData.item_count === 0;
    });
  }
}

customElements.define('cart-drawer-component', CartDrawer);

// Handle Add To Cart globally
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form) return;
  
  e.preventDefault();
  
  const submitBtn = form.querySelector('[type="submit"]');
  if (submitBtn) {
    submitBtn.dataset.originalText = submitBtn.textContent;
    submitBtn.textContent = 'Adding...';
    submitBtn.disabled = true;
  }

  try {
    const formData = new FormData(form);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    });
    const item = await response.json();
    
    // Refresh the cart drawer
    const drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent) {
      const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await cartRes.json();
      await drawerComponent.renderCart(cartData);
      drawerComponent.open();
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    alert('Failed to add item to cart. Please try again.');
  } finally {
    if (submitBtn) {
      submitBtn.textContent = submitBtn.dataset.originalText;
      submitBtn.disabled = false;
    }
  }
});
